import vueTips from './tips.vue'

let Tips = {}

// 只有定义了 install 方法，才能使用 Vue.use() 进行引用
Tips.install = function (Vue) {
  // 添加实例方法 - 扩展方法
  Vue.prototype.$tips = function (msg, interval) {
    const TipsController = Vue.extend(vueTips)
    const lastTips = document.getElementsByClassName('m-prompt')
    if (lastTips.length > 0) {
      for (let i = 0; i < lastTips.length; ++i) {
        document.body.removeChild(lastTips[i])
      }
    }
    const dom = document.createElement('div')
    let instance = new TipsController().$mount(dom)
    instance.msg = msg
    if (msg) {
      instance.show = true
    }
    if (!interval) {
      interval = 2500
    }
    instance.interval = interval

    document.body.appendChild(instance.$el)

    setTimeout(() => {
      instance.showFlag = false
      setTimeout(() => {
        if (instance.$el.parentNode) {
          document.body.removeChild(instance.$el)
        }
      }, 500)
    }, interval)
  }
  Vue.prototype.$tips.shows = function (msg, interval) {
    Vue.prototype.$tips(msg, interval)
  }
}

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(Tips)
}

export default Tips



// WEBPACK FOOTER //
// ./src/components/base/tips/index.js